import React from "react";
const SharedStateContext = React.createContext();
export default SharedStateContext;
